export const BASE_URL = process.env.REACT_APP_GETWAY_API || "";
export const API_KEY = process.env.REACT_APP_API_KEY || "";
